<div class="edl-modal-date-picker-content d-flex">
    <form [formGroup]="form" (ngSubmit)="submit(form)">
        <div class="modal-header">
            <h4 class="modal-title">{{title}}</h4>
        </div>
        <div class="modal-body">
            <label class="form-label">{{label}}</label>
            <div class="d-flex flex-row align-items-center justify-content-between">
                <edl-date-picker formControlName="datePicker" container="body" class="me-4"></edl-date-picker>
                <timepicker formControlName="timePicker" clas="text-dark"></timepicker>
            </div>
        </div>
        <div class="modal-footer">
            <button type="submit" class="btn btn-success" [disabled]="form.invalid">Submit</button>
            <button type="button" class="btn btn-info" (click)="cancel()">Cancel</button>
        </div>
    </form>
</div>